module.exports = __webpack_public_path__ + "static/media/maps.0a1e67cf.svg";